import script from "./BodorPlus.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorPlus.vue?vue&type=script&setup=true&lang=js"

import "./BodorPlus.vue?vue&type=style&index=0&id=5d1d0d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1d0d50"]])

export default __exports__